export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const accountTypes = [
  {
    id: "Internal",
    text: "Internal",
  },
  {
    id: "External",
    text: "External",
  },
];

export const accountStatus = [
  {
    id: "On Leave",
    text: "On Leave",
  },
  {
    id: "Active",
    text: "Active",
  },
  {
    id: "Block",
    text: "Block",
  },
];

export const assignmentList = [
  {
    id: "CIT",
    text: "CIT",
  },
  {
    id: "ATM",
    text: "ATM",
  },
  {
    id: "HUB",
    text: "HUB",
  },
  {
    id: "FLM",
    text: "FLM",
  },
  {
    id: "Customer",
    text: "Customer",
  },
  {
    id: "NA",
    text: "NA",
  },
];

export const staffTypes = [
  {
    id: "Field Staff",
    text: "Field Staff",
  },
  {
    id: "Office Based Staff",
    text: "Office Based Staff",
  },
];

export const formDefaultValues = {
  employeeId: "",
  userName: "",
  password: "",
  firstName: "",
  lastName: "",
  nationality: "",
  email: "",
  personalEmail: "",
  accountType: null,
  mobileNumber: "",
  personalMobileNumber: "",
  accountStatus: null,
  designation: "",
  assignment: null,
  dateOfBirth: null,
  dateOfJoining: null,
  nationalId: "",
  nationalIdExpiry: null,
  passportNumber: "",
  passwordExpiry: null,
  drivingLicenseNo: "",
  drivingExpiry: null,
  cashCenter: null,
  office: null,
  clientId: "",
  roles: [],
  cenconId: "",
  staffType: "",
  businessUnit: "",
  state: "",
  city: "",
  emirate: "",
  managerId: "",
  isAzureAd: { text: "No", id: false },
};

export const formValidationRules = {};

export const editUserFormValued = (
  payload,
  cashCenterList,
  nationalities,
  designations,
  rolesList,
  officesData,
  assignmentGroups,
  clientsList
) => {
  let nationality = "";
  let accountType = null;
  let _accountStatus = null;
  let _designation = null;
  let _assignment = null;
  let _cashCenter = null;
  let _office = null;
  let _roles = [];
  if (payload.nationality) {
    const temp = nationalities.filter(
      (elm) => elm.name.toLowerCase() === payload.nationality.toLowerCase()
    );
    if (temp.length > 0) {
      nationality = temp[0];
    }
  }

  if (payload.accountType) {
    const temp = accountTypes.filter((elm) => elm.id === payload.accountType);
    if (temp.length > 0) {
      accountType = temp[0];
    }
  }

  if (payload.status) {
    const temp = accountStatus.filter((elm) => elm.id === payload.status);

    if (temp.length > 0) {
      _accountStatus = temp[0];
    }
  }

  if (payload.designation) {
    const temp = designations.filter(
      (elm) => elm.description === payload.designation
    );
    if (temp.length > 0) {
      _designation = temp[0];
    } else {
      _designation = { description: payload.designation };
    }
  }
  if (payload.assignment) {
    const temp = assignmentGroups.filter(
      (elm) => elm.id === payload.assignment
    );
    if (temp.length > 0) {
      _assignment = temp[0];
    } else {
      _assignment = { text: payload.assignment, id: payload.assignment };
    }
  }

  if (payload.cashCenterId) {
    const temp = cashCenterList.filter(
      (elm) => elm.cashCenterId === payload.cashCenterId
    );
    if (temp.length > 0) {
      _cashCenter = temp[0];
    }
  }

  if (payload.officeId) {
    const temp = officesData.filter((elm) => elm.officeId === payload.officeId);
    if (temp.length > 0) {
      _office = temp[0];
    }
  }

  if (payload.roles && payload.roles.length) {
    _roles = rolesList
      .filter((elm) => payload.roles.findIndex((r) => r === elm.name) !== -1)
      .map((elm) => ({
        name: elm.name,
      }));
  }

  let _clientId = payload.clientId;
  if (payload.clientId && clientsList) {
    const _clientIdIndex = clientsList.findIndex(
      (elm) => elm.clientId === payload.clientId
    );
    if (_clientIdIndex !== -1) {
      _clientId = clientsList[_clientIdIndex];
    } else {
      _clientId = { clientId: _clientId, name: _clientId };
    }
  }

  const values = {
    ...payload,
    nationality,
    accountType,
    mobileNumber: payload.mobileNo,
    personalMobileNumber: payload.personalMobileNo,
    accountStatus: _accountStatus,
    designation: _designation,
    assignment: _assignment,
    dateOfBirth: payload.dateOfBirth ? new Date(payload.dateOfBirth) : null,
    dateOfJoining: payload.dateOfJoining
      ? new Date(payload.dateOfJoining)
      : null,
    nationalIdExpiry: payload.nationalIdExpiry
      ? new Date(payload.nationalIdExpiry)
      : null,
    passportNumber: payload.passportNo,
    passportExpiry: payload.passportExpiry
      ? new Date(payload.passportExpiry)
      : null,
    drivingExpiry: payload.drivingLicenseExpiry
      ? new Date(payload.drivingLicenseExpiry)
      : null,
    cashCenter: _cashCenter,
    office: _office,
    clientId: _clientId,
    roles: _roles,
    staffType: { id: payload.staffType, text: payload.staffType },
    businessUnit: { id: payload.businessUnit, text: payload.businessUnit },
    state: { id: payload.state, text: payload.state },
    city: { id: payload.city, text: payload.city },
    emirate: { id: payload.emirate, text: payload.emirate },
    isAzureAd: payload.isAzureAd
      ? { text: "Yes", id: true }
      : { text: "No", id: false },
  };

  return values;
};

export const secureFields = [
  "designation",
  "state",
  "city",
  "emirate",
  "drivingLicenseNo",
  "passportNo",
  "nationalId",
  "personalEmail",
  "personalMobileNo",
  "managerId",
];
